import React, { Fragment, useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';
import { StarRating } from '../../../Constant';

const StarRatingClass = () => {
  const [rating, setRating] = useState(3);
  return (
    <Fragment>
      <Col xl='6' lg='12' md='6'>
        <Card>
          <HeaderCard title={StarRating} />
          <CardBody>
            <div className='rating'>
              <Rating size={'16px'} initialRating={rating} emptySymbol='star fa fa-star-o fa-2x' fullSymbol='star fa fa-star fa-2x' onChange={(rate) => setRating(rate)}></Rating>
              <span className='current-rating'>{rating}</span>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default StarRatingClass;
